import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
@Component({
  selector: 'app-admin-validation-modal',
  templateUrl: './admin-validation-modal.component.html',
  styleUrls: ['./admin-validation-modal.component.css'],
})
export class AdminValidationModalComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<AdminValidationModalComponent>) {}

  ngOnInit(): void {}
  closeDialog(): void {
    this.dialogRef.close();
  }
}
